import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import Hidden from "@material-ui/core/Hidden";
import Button from "@material-ui/core/Button";
import Logo from "./Logo";
import Grid from "@material-ui/core/Grid";
import SubmitModal from "../components/SubmitModal";
import LeaveConfirmationModal from "./LeaveConfirmationModal";
import KeyboardCoverOverlay from "./KeyboardCoverOverlay";

import {
  StyledHeaderActions,
  SummaryViewBox,
  StyledSummaryImageWrapper,
  StyledCircleButton,
  StyledSummaryInfo,
  StyledBigButton,
  StyledStatCard,
  SummaryViewBoxWrapper,
} from "./common.styles";
import Watermark from "./Watermark";

const Summary = ({ history, location, onClose }) => {
  const [disableMediaQuery, setDisableMediaQuery] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [
    leaveConfirmationModalRedirect,
    setLeaveConfirmationModalRedirect,
  ] = useState("");

  if (!location.state) {
    return <Typography>Ups, something wen't wrong</Typography>;
  }

  const handleClose = () => {
    setOpenForm(false);
  };

  const handleRedirect = () => {
    window.location.href = leaveConfirmationModalRedirect;
  };

  const images = location.state.images;
  const model = location.state.model;
  const backgroundImage = location.state.backgroundImage;

  return (
    <SummaryViewBoxWrapper>
      <StyledHeaderActions className="locked">
        <Box flex="1" />
        <Hidden smUp>
          <StyledCircleButton onClick={() => onClose()}>
            <img src={require("../../assets/close.png")} />
          </StyledCircleButton>
        </Hidden>
        <Hidden smDown>
          <Chip
            color="secondary"
            label="Back to Editor"
            onClick={() => onClose()}
          />
        </Hidden>
      </StyledHeaderActions>
      <SummaryViewBox
        id="summaryViewBox"
        className={disableMediaQuery ? "disable-query" : ""}
      >
        <StyledSummaryImageWrapper
          className={disableMediaQuery ? "disable-query" : ""}
        >
          {images.map((image, i) => (
            <Box>
              <Typography variant="caption">{image.name}</Typography>

              <Box
                style={{
                  backgroundImage: location.state.backgroundImage
                    ? `url(${location.state.backgroundImage})`
                    : "none",
                  backgroundColor: !location.state.backgroundImage
                    ? "#f3f3f3"
                    : "transparent",
                }}
              >
                <Box
                  style={{
                    backgroundImage: `url(${image.value})`,
                    position: "relative",
                  }}
                >
                  {!disableMediaQuery && <Watermark />}
                </Box>
              </Box>
            </Box>
          ))}
        </StyledSummaryImageWrapper>
        <StyledSummaryInfo className={disableMediaQuery ? "disable-query" : ""}>
          <Typography
            variant="caption"
            style={{ textTransform: "uppercase", fontWeight: "bold" }}
          >
            Configuration Completed
          </Typography>
          <Box mt={0.3} />
          <Typography variant="h4">Here is your {model.name} robot</Typography>
          <Box mt={1} />
          <Typography>{model.copy}</Typography>
          <Box mt={1} />
          <Grid container spacing={1}>
            <Grid item xs={6} sm={6}>
              <StyledStatCard>
                <Typography variant="h3">
                  {model.specs.speed
                    ? `${model.specs.speed} mph`
                    : "Stationary"}
                </Typography>
                <Typography variant="caption">Maximum Speed</Typography>
              </StyledStatCard>
            </Grid>
            <Grid item xs={6} sm={6}>
              <StyledStatCard>
                <Typography variant="h3">{model.specs.terrain}</Typography>
                <Typography variant="caption">Terrain Capability</Typography>
              </StyledStatCard>
            </Grid>
            <Grid item xs={6} sm={6}>
              <StyledStatCard>
                <Typography variant="h3">{model.specs.weight} lbs.</Typography>
                <Typography variant="caption">Weight</Typography>
              </StyledStatCard>
            </Grid>
            <Grid item xs={6} sm={6}>
              <StyledStatCard>
                <Typography variant="h3">{model.specs.dimensions}</Typography>
                <Typography variant="caption">
                  Dimensions (W × H × L)
                </Typography>
              </StyledStatCard>
            </Grid>
          </Grid>

          {!disableMediaQuery && (
            <>
              <Box mt={1} />
              <StyledBigButton
                onClick={() =>
                  setLeaveConfirmationModalRedirect(model.detailsUrl)
                }
              >
                LEARN MORE ABOUT ROBOT CAPABILITIES
              </StyledBigButton>
              <Box mt={1} />
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => setOpenForm(true)}
                  >
                    Submit for approval
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    onClick={() =>
                      setLeaveConfirmationModalRedirect(
                        "https://www.knightscope.com/demo"
                      )
                    }
                  >
                    Request a demo
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </StyledSummaryInfo>
      </SummaryViewBox>

      <SubmitModal
        onPreSubmit={() => setDisableMediaQuery(true)}
        modalOpen={openForm}
        onSubmitSuccess={() => history.push("/")}
        onClose={handleClose}
        images={images}
        modelName={model.name}
        backgroundImage={backgroundImage}
      />

      <LeaveConfirmationModal
        modalOpen={leaveConfirmationModalRedirect}
        onConfirm={handleRedirect}
        onClose={() => setLeaveConfirmationModalRedirect("")}
      />
      <KeyboardCoverOverlay />
    </SummaryViewBoxWrapper>
  );
};

export default Summary;
